import { lazy } from 'react';

const Dashboard = lazy(() => import('../pages/marketer/Dashboard.jsx'));
const BlogPosts = lazy(() => import('../pages/marketer/BlogPosts.jsx'));
const AddBlogPost = lazy(() => import('../pages/marketer/AddBlogPost.jsx'));
const EditBlogPost = lazy(() => import('../pages/marketer/EditBlogPost.jsx'));
const BlogPreview = lazy(() => import('../pages/marketer/BlogPreview.jsx'));
const BlogCategories = lazy(() => import('../pages/marketer/BlogCategories.jsx'));
const BlogTags = lazy(() => import('../pages/marketer/BlogTags.jsx'));
const SeoMetaManager = lazy(() => import('../pages/marketer/SeoMetaManager.jsx'));
const ProductSeo = lazy(() => import('../pages/marketer/ProductSeo.jsx'));
const CategorySeo = lazy(() => import('../pages/marketer/CategorySeo.jsx'));
const BrandSeo = lazy(() => import('../pages/marketer/BrandSeo.jsx'));
const LandingPages = lazy(() => import('../pages/marketer/LandingPages.jsx'));
const BannerManager = lazy(() => import('../pages/marketer/BannerManager.jsx'));
const AdsManager = lazy(() => import('../pages/marketer/AdsManager.jsx'));
const FaqManager = lazy(() => import('../pages/marketer/FaqManager.jsx'));
const RedirectManager = lazy(() => import('../pages/marketer/RedirectManager.jsx'));
const SitemapManager = lazy(() => import('../pages/marketer/seo/SitemapManagerPage.jsx'));
const RobotsManager = lazy(() => import('../pages/marketer/seo/RobotsManagerPage.jsx'));
const SchemaManager = lazy(() => import('../pages/marketer/SchemaManager.jsx'));
const SeoAudit = lazy(() => import('../pages/marketer/SeoAudit.jsx'));
const Analytics = lazy(() => import('../pages/marketer/Analytics.jsx'));
const ContentCalendar = lazy(() => import('../pages/marketer/ContentCalendar.jsx'));
const MediaLibrary = lazy(() => import('../pages/marketer/MediaLibrary.jsx'));

const marketerRoutes = [
  { path: '', Component: Dashboard },
  { path: 'dashboard', Component: Dashboard },
  { path: 'blogs', Component: BlogPosts },
  { path: 'blogs/add', Component: AddBlogPost },
  { path: 'blogs/edit/:id', Component: EditBlogPost },
  { path: 'blog', Component: BlogPosts },
  { path: 'blog/add', Component: AddBlogPost },
  { path: 'blog/edit/:id', Component: EditBlogPost },
  { path: 'blog/preview/:id', Component: BlogPreview },
  { path: 'blog/new', Component: AddBlogPost },
  { path: 'blog/:id/edit', Component: EditBlogPost },
  { path: 'blog-categories', Component: BlogCategories },
  { path: 'blog-tags', Component: BlogTags },
  { path: 'seo-meta', Component: SeoMetaManager },
  { path: 'product-seo', Component: ProductSeo },
  { path: 'category-seo', Component: CategorySeo },
  { path: 'brand-seo', Component: BrandSeo },
  { path: 'seo-products', Component: ProductSeo },
  { path: 'seo-categories', Component: CategorySeo },
  { path: 'seo-brands', Component: BrandSeo },
  { path: 'landing-pages', Component: LandingPages },
  { path: 'banners', Component: BannerManager },
  { path: 'ads', Component: AdsManager },
  { path: 'faqs', Component: FaqManager },
  { path: 'faq', Component: FaqManager },
  { path: 'redirects', Component: RedirectManager },
  { path: 'sitemap', Component: SitemapManager },
  { path: 'robots', Component: RobotsManager },
  { path: 'schema', Component: SchemaManager },
  { path: 'seo-audit', Component: SeoAudit },
  { path: 'analytics', Component: Analytics },
  { path: 'content-calendar', Component: ContentCalendar },
  { path: 'media', Component: MediaLibrary },
];

export default marketerRoutes;
